const NotFound = () => {
	return <div>Page Not Founds</div>;
};

export { NotFound };
